/**
 * As listas do painel "Rodar de novo", tiradas da grade-base.
 *
 * Só entra o que está na grade: não há como congelar uma disciplina que nem
 * foi alocada, e oferecer a lista inteira do cadastro (401 disciplinas na
 * ESPM) esconderia as que importam. Ver `PESQUISA-ESPM.md` §24.1.
 *
 * Fora de `.tsx` para o Node testar.
 */

export interface Opcao {
  id: string
  nome: string
  /** Quantas aulas desta opção a grade tem — é o que a pessoa vai congelar. */
  aulas: number
}

interface AulaDaGrade {
  tipo: string
  turma_id: string | null
  turma: string | null
  disciplina_id: string | null
  disciplina: string | null
  professores_ids: string[]
  professores: string[]
}

const porNome = (a: Opcao, b: Opcao) => a.nome.localeCompare(b.nome, 'pt-BR', { numeric: true })

export function opcoesDaGrade(alocacoes: readonly AulaDaGrade[]): {
  turmas: Opcao[]
  professores: Opcao[]
  disciplinas: Opcao[]
} {
  const turmas = new Map<string, Opcao>()
  const professores = new Map<string, Opcao>()
  const disciplinas = new Map<string, Opcao>()
  const contar = (m: Map<string, Opcao>, id: string | null, nome: string | null) => {
    if (!id) return
    const o = m.get(id) ?? { id, nome: nome ?? id, aulas: 0 }
    o.aulas++
    m.set(id, o)
  }
  for (const a of alocacoes) {
    if (a.tipo !== 'AULA') continue
    contar(turmas, a.turma_id, a.turma)
    contar(disciplinas, a.disciplina_id, a.disciplina)
    a.professores_ids.forEach((id, i) => contar(professores, id, a.professores[i] ?? null))
  }
  return {
    turmas: [...turmas.values()].sort(porNome),
    professores: [...professores.values()].sort(porNome),
    disciplinas: [...disciplinas.values()].sort(porNome),
  }
}
